// components/BreadcrumbsBar.jsx
import React from "react";
import {
  Breadcrumbs,
  Typography,
  Link as MuiLink,
  Divider,
} from "@mui/material";
import { Link, useLocation, useParams } from "react-router-dom";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const titleMap = {
  
  report: "Report Management",
  compound: "Compound",
  cmt_management : "CMT Mangement",
  financial:"Financial Management",
  subscription: "Subscriptions",
  setting:"System Setting",
  issue_management:"Issue Management",
  activity_logs:"Activity Logs",
  system_health:"System Health",
  backup_restore:"Backup & Restore",
  dashboard: "Home",
  
  notification: "Notifications",
};

const BreadcrumbsBar = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  const params = useParams();
  return (
    <div>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        <HomeOutlinedIcon sx={{ m: 0.5 }} fontSize="large" />
        <MuiLink component={Link} underline="hover" color="inherit" to="/">
          <Typography>Home</Typography>
        </MuiLink>

        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;

          // Dynamically label compound/dashboard/:id
          const isUUID = /^[0-9a-fA-F-]{36}$/.test(value);
          const label =
            isUUID && pathnames[index - 1] === "compound"
              ? `Compound #${value.slice(0, 6)}`
              : titleMap[value] ||
                value.charAt(0).toUpperCase() + value.slice(1);

          return isLast ? (
            <Typography color="text.primary" key={to}>
              {label}
            </Typography>
          ) : (
            <MuiLink
              component={Link}
              to={to}
              key={to}
              underline="hover"
              color="inherit"
            >
              {label}
            </MuiLink>
          );
        })}
      </Breadcrumbs>
      <Divider sx={{ my: 1 }} />
    </div>
  );
};

export default BreadcrumbsBar;
